import { ChildStep, ParentStep } from '@/types/steps';

export const computeSummaryPath = (
  parent?: ParentStep<unknown>,
  child?: ChildStep<unknown>,
): string => {
  return ['/verify-business/summary', parent?.path ?? 'invalid', child?.path ?? 'invalid'].join(
    '/',
  );
};
